import { Outlet } from 'react-router-dom'
import ManagementNav from 'components/navs/ManagementNav'

const ManagementLayout = () => {
  return (
    <div>
      <ManagementNav />
      <div className='p-6 bg-white shadow-md border border-gray-300 border-t-0'>
        <Outlet />
      </div>
    </div>
  )
}

export default ManagementLayout
